import { Icon } from '@natera/material/lib/icon'
import { Collapsible } from 'radix-ui'
import { useState, type PropsWithChildren, type ReactNode } from 'react'
import { Text } from '~/shared/ui'

export function Disclosure({
  label,
  defaultOpen = false,
  children,
}: PropsWithChildren<{ label: ReactNode; defaultOpen?: boolean }>) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <Collapsible.Root
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Collapsible.Trigger className="text-text-secondary hover:text-text-primary flex cursor-pointer items-center gap-1 border-none bg-transparent p-0 text-left outline-none">
        <Icon className="text-[18px]">{isOpen ? 'expand_more' : 'chevron_right'}</Icon>
        <Text appearance="CAPTION">{label}</Text>
      </Collapsible.Trigger>
      <Collapsible.Content className="mt-2">{children}</Collapsible.Content>
    </Collapsible.Root>
  )
}
